import { Table, TableHead, TableRow, TableHeaderCell, TableCell } from './ui/Table'
import UiInput from './ui/Input'
import React from "react";
import { employeeRateFieldKeys, normalizeEmployeeRates } from "../utils/workerRates";

const sections = [
    { key: 'day', title: '6am - 6pm' },
    { key: 'night', title: '6pm - 6am' },
];

const rowLabels = {
    weekdayBaseRate: "Monday to Friday - Base rate (8 hours)",
    weekdayOvertime0To2Rate: "Monday to Friday - Overtime 0-2hrs",
    weekdayOvertime2PlusRate: "Monday to Friday - Overtime +2hrs",
    saturdayFirst2Rate: "Saturday - First 2 hours",
    saturday2PlusRate: "Saturday - +2hrs",
    sundayAllDayRate: "Sunday - All day",
    mealAllowance: "Meal allowance",
    travelAllowance: "Travel allowance",
};

export default function EmployeeRatesTable({ rates, setRates, editing = false }) {
    const normalizedRates = normalizeEmployeeRates(rates);

    const disableScrollChange = (e) => e.target.blur();

    const updateRate = (period, field, value) => {
        const next = normalizeEmployeeRates(rates);
        next[period][field] = value;
        setRates(next);
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {sections.map(section => (
                <div key={section.key} className="overflow-x-auto">
                    <Table emptyItems="rates" className="min-w-full border border-gray-300 text-sm">
                        <TableHead className="bg-gray-100">
                            <TableRow>
                                <TableHeaderCell className="border border-gray-300 px-3 py-2 text-left">{section.title}</TableHeaderCell>
                                <TableHeaderCell className="border border-gray-300 px-3 py-2 text-center">Rate / Amount</TableHeaderCell>
                            </TableRow>
                        </TableHead>
                        <tbody>
                            {employeeRateFieldKeys.map(field => (
                                <TableRow key={`${section.key}-${field}`}>
                                    <TableCell className="border border-gray-300 px-3 py-2 font-medium">{rowLabels[field]}</TableCell>
                                    <TableCell className="border border-gray-300 px-2 py-1 text-center">
                                        <UiInput
                                            type="number"
                                            value={normalizedRates[section.key][field] ?? ""}
                                            onChange={(e) => updateRate(section.key, field, e.target.value)}
                                            onWheel={disableScrollChange}
                                            className={`w-24 border rounded p-1 text-center ${editing
                                                ? "bg-white focus:ring-2 focus:ring-blue-400"
                                                : "bg-gray-100 cursor-not-allowed"
                                                }`}
                                            disabled={!editing}
                                            placeholder="0"
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}
                        </tbody>
                    </Table>
                </div>
            ))}
        </div>
    );
}
